module.exports = __webpack_public_path__ + "resources/img/equipment_tab2_img5_m.e45cc815929a7b4259c0556c8b7e91ee.jpg";